import { render, staticRenderFns } from "./LNB.vue?vue&type=template&id=2f9ee12f&scoped=true&"
import script from "./LNB.vue?vue&type=script&lang=js&"
export * from "./LNB.vue?vue&type=script&lang=js&"
import style0 from "./LNB.vue?vue&type=style&index=0&id=2f9ee12f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9ee12f",
  null
  
)

export default component.exports